import React, { useEffect, useState } from "react";
import { Button, Card, Divider, Image, Input, Space, Typography } from "antd";
import ApiInventarioProductos from "../../../../../js/api/global/InventarioProductos";
import { openNotification } from "../../../../controls/Notifications";
import helperSession from "../../../../../js/helpers/helpersSession";
import { ReconciliationOutlined } from "@ant-design/icons";
import ApiMedidas from "../../../../../js/api/global/Medidas";
import ApiInventarioProductoLog from "../../../../../js/api/global/InventarioProductoLog";
import { imageProductExample } from "../../../../../img/product-image.example";

const { Title, Text } = Typography;
const CountInventorieInsertDetail = ({
  producto,
  setProducto,
  resetCodigoBarra,
}) => {
  const [loading, setLoading] = useState(false);
  const isAccountant = helperSession.GetAccount("rol") === "Contador";
  const isAdmin = helperSession.GetAccount("rol") === "Admin";
  const isSupervisor = helperSession.GetAccount("rol") === "Supervisor";

  const [quantyProduct, setQuantyProduct] = useState(0);
  const [medidas, setMedidas] = useState(null);

  const aceptaDecimales = medidas?.aceptaDecimales;

  useEffect(() => {
    if (producto && producto.idMedida) {
      ApiMedidas.GetMedidasList(producto.idMedida)
        .then((response) => {
          if (response.success) {
            setMedidas(response.data);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la medida:", error);
        });
    }
  }, [producto]);

  const updateQuanty = (isSum) => {
    if (!loading && !(isAccountant && quantyProduct === 0)) {
      setLoading(true);

      const InventarioProductoLogToSave = {
        idInventarioProducto: producto?.id,
        cantidadIgresada: quantyProduct,
        accion: isSum ? "Sumar" : "Actualizar conteo",
      };

      const { idProductoSucursal, idInventario } = producto;

      const cantidad = isAccountant
        ? parseFloat(quantyProduct)
        : isSum
        ? producto.cantidad + parseFloat(quantyProduct)
        : parseFloat(quantyProduct);

      const productToSave = {
        idProductoSucursal,
        idInventario,
        medidad: "",
        categoria: "",
        cantidad,
      };

      ApiInventarioProductos.PostInventarioProducto(productToSave).then(
        (resp) => {
          if (resp.success) {
            if (producto?.id !== 0) {
              ApiInventarioProductoLog.PostInventarioProductoLog(
                InventarioProductoLogToSave
              );
            } else {
              console.error('La id de idInventarioProducto no existe')
            }
            setLoading(false);
            openNotification(
              "s",
              "Guardado exitoso",
              "Se ha guardado correctamente"
            );
            resetCodigoBarra();
            setProducto(null);
          } else {
            console.error("e", "Error de guardado", resp.message);
          }
        }
      );
    }
  };
  if (!producto) return "";

  return (
    <Card
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h4
            style={{
              wordWrap: "break-word",
              margin: 0,
              whiteSpace: "normal",
            }}
          >
            <ReconciliationOutlined style={{ color: "#1677FF" }} /> Detalles del
            Producto
          </h4>
        </div>
      }
      bordered={true}
      style={{
        maxWidth: "400px",
        margin: "0 auto",
      }}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Title
          level={4}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {producto.productoSucursal}
        </Title>
        <Divider style={{ marginTop: 0, marginBottom: 8 }} />
        <div
          style={{ display: "flex", justifyContent: "center", marginBottom: 8 }}
        >
          <Image
            width={200}
            height={200}
            alt="nombre del producto"
            src={imageProductExample}
          />
        </div>

        <Text>
          Categoría: <Text strong>{producto.categoria}</Text>
        </Text>
        <Text>
          Código: <Text strong>{producto.codigoBarra}</Text>
        </Text>
        <Text>
          Código maestra: <Text strong>{producto.codigoMaestra}</Text>
        </Text>
        <Text>
          Cantidad:{" "}
          <Text strong>{String(producto.cantidad).replace(".", ",")}</Text>
        </Text>
        <Text>
          Unidad de medida:{" "}
          <Text
            strong
          >{`${medidas?.descripcion} - ${medidas?.unidadMedida}`}</Text>
        </Text>
        {producto.usuario && (
          <Text>
            Última modificación: <Text strong>{producto.usuario}</Text>
          </Text>
        )}
        <Divider />
        <Input
          type="number"
          step={aceptaDecimales ? 0.5 : 1}
          maxLength={6}
          min={0}
          autoFocus={true}
          onPressEnter={isAccountant && updateQuanty}
          onChange={(e) => {
            let value = e.target.value;
            value = value.replace(",", "");
            if (value === "") {
              setQuantyProduct(value);
              return;
            }

            let regex;
            if (aceptaDecimales) {
              regex = /^(\d+(\.\d*)?)$/;
            } else {
              regex = /^\d+$/;
            }

            if (regex.test(value)) {
              setQuantyProduct(value);
            }
          }}
          value={quantyProduct || ""}
          placeholder="Cantidad"
          style={{ width: "100%" }}
        />

        <Space>
          <Button
            type="primary"
            loading={loading}
            onClick={() => updateQuanty(true)}
            disabled={!quantyProduct}
          >
            Sumar
          </Button>
          {(isAdmin || isSupervisor) && (
            <Button
              type="primary"
              loading={loading}
              onClick={() => updateQuanty(false)}
              disabled={quantyProduct < 0 || !quantyProduct}
            >
              Actualizar
            </Button>
          )}
        </Space>
      </Space>
    </Card>
  );
};

export default CountInventorieInsertDetail;
